import { useEffect, useState } from 'react';
import templateWizardFormDefaults from '../../constants/templateWizardFormDefaults';
import templateWizardTemplates from '../../constants/templateWizardTemplates';
import useFetch from '../../helpers/useFetch';

const useTemplate = (accountId, domainId, templateId, extraWatch) => {
  const [template, setTemplate] = useState();
  const fetch = useFetch();

  useEffect(() => {
    if (!templateId) {
      // No layout chosen is "nothing to load", not "still loading" — the same
      // state a fetch that resolves not-found already reports below. Without
      // this, `template` sat at its initial `undefined` forever, and a caller
      // like `usePreview` cannot tell that apart from "the fetch is still in
      // flight": both read `undefined`, so a block created with no layout got
      // a spinner that never resolved instead of an empty preview. This also
      // clears a template left over from a layout the author just unset,
      // rather than leaving the previous one's `template` object stale.
      setTemplate(null);
      return;
    }

    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/templates/${templateId}`).then(({ template }) => {
      if (!template) {
        setTemplate(null);
        return;
      }

      if (!template.advancedEditor) {
        template.body = templateWizardTemplates[template.scope];
        // A row created outside the wizard (an api post, a cross-domain copy) can
        // carry a null or partial wizardFormData; any section it lacks - missing
        // outright or stored as null - takes the defaults, so the wizard form and
        // the style transform always have something to read. A plain spread would
        // not do: an explicit null overrides the default it is spread over.
        // Cloned, so edits never mutate the shared constant.
        const storedWizardFormData = template.wizardFormData ?? {};
        template.wizardFormData = structuredClone(templateWizardFormDefaults);
        Object.entries(storedWizardFormData).forEach(([section, value]) => {
          if (value !== null && value !== undefined) {
            template.wizardFormData[section] = value;
          }
        });
        template.wizardFormData.arrowsStyles.centered ??= false;

        if (!template.wizardFormData.blockStyles.fluidContainer) {
          template.wizardFormData.blockStyles.fluidContainer = false;
          template.wizardFormData.blockStyles.width = 1140;
        }
      } else {
        template.wizardFormData = structuredClone(templateWizardFormDefaults);
      }
      setTemplate(template);
    });
  }, [accountId, domainId, fetch, templateId, extraWatch]);

  return template;
};
export default useTemplate;
